import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IDealerInformationVDF } from '../models/model'

export class GetDealerInformationListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/vodafoneDealer/getDealerInformationVDF',
      requesterInfo,
    })
  }

  public async getDealerInformationList(): Promise<IDealerInformationVDF[]> {
    return await this.getAsync<IDealerInformationVDF[]>()
  }
}
